import { Routes } from '@angular/router';
import { DATA_SLUGS } from '@routes/routes.types';

import { TicketLayoutComponent } from './ticket-layout.component';

export const TICKET_ROUTES: Routes = [
    // Full-screen wizard — rendered OUTSIDE the ticket layout so it has no page
    // title / submenu chrome. Must precede the layout route to win matching.
    {
        path: `${DATA_SLUGS.ticketConfig}/new`,
        title: 'New Ticket Configuration',
        loadComponent: () =>
            import(
                '@features/ticket/ticket-configuration/ticket-configuration.component'
            ).then(m => m.TicketConfigurationComponent),
    },
    {
        path: `${DATA_SLUGS.ticketConfig}/edit/:id`,
        title: 'Edit Ticket Configuration',
        loadComponent: () =>
            import(
                '@features/ticket/ticket-configuration/ticket-configuration.component'
            ).then(m => m.TicketConfigurationComponent),
    },
    {
        path: '',
        component: TicketLayoutComponent,
        children: [
            {
                path: DATA_SLUGS.ticket,
                title: 'Ticket',
                loadComponent: () =>
                    import('@features/ticket/ticket-list/ticket-list.component').then(
                        m => m.TicketListComponent
                    ),
            },
            {
                path: DATA_SLUGS.adminFields,
                title: 'Fields',
                loadComponent: () =>
                    import('@features/ticket/admin-fields-list/admin-fields-list.component').then(
                        m => m.AdminFieldsListComponent
                    ),
            },
            {
                path: DATA_SLUGS.stage,
                title: 'Stage',
                loadComponent: () =>
                    import('@features/ticket/admin-stages-list/admin-stages-list.component').then(
                        m => m.AdminStagesListComponent
                    ),
            },
            {
                path: DATA_SLUGS.ticketConfig,
                title: 'Ticket Configuration',
                loadComponent: () =>
                    import(
                        '@features/ticket/ticket-configuration/list/ticket-configuration-list.component'
                    ).then(m => m.TicketConfigurationListComponent),
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: DATA_SLUGS.ticket,
            },
        ],
    },
] as const;

